import { Button, Grid, Link, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as React from "react";
import { Teacher } from "@app/shared/types";
import { shortenedText } from "@app/shared/utils";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(4),
    },

    card: {
        borderRadius: theme.borderRadius.default,

        "& img": {
            width: "100%",
            borderRadius: "20px 20px 0px 0px",
            marginBottom: -10,
        },
    },

    picture: {
        cursor: "pointer",
    },

    cardContents: {
        padding: theme.spacing(2, 2, 4),
        borderColor: theme.palette.grey700,
        borderTopWidth: 0,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderStyle: "solid",
        borderRadius: "0px 0px 20px 20px",

        "& h4": {
            marginTop: theme.spacing(2),
        },
    },

    linkSection: {
        display: "flex",
        justifyItems: "middle",
        marginTop: theme.spacing(4),

        "&:hover": {
            color: theme.palette.aqua700,
        },

        "& span": {
            marginRight: theme.spacing(2),
        },
    },
}));

export const TeacherCard = (props: {
    teacher: Teacher;
    onOpenProfile: (ev: React.MouseEvent<any>) => void;
}) => {
    const classes = useStyles();

    const { teacher, onOpenProfile } = props;

    return (
        <Grid item lg={3} md={3} sm={6} xs={12} className={classes.root}>
            <div className={classes.card}>
                <div
                    className={classes.picture}
                    onClick={onOpenProfile}
                    style={{
                        backgroundImage: `url("${teacher.picture}")`,
                        backgroundSize: "cover",
                        backgroundPosition: "50% 50%",
                        borderRadius: "20px 20px 0px 0px",
                        width: "100%",
                        height: 300,
                    }}
                />

                <div className={classes.cardContents}>
                    <Typography variant="h4">{teacher.name}</Typography>
                    <Typography variant="body2">
                        {shortenedText(teacher.quote || "", 160)}
                    </Typography>

                    <div>
                        <Button
                            variant="tertiary"
                            className={classes.linkSection}
                            onClick={onOpenProfile}
                        >
                            Learn more about {teacher.name}
                            <ArrowForwardIcon />
                        </Button>
                    </div>
                </div>
            </div>
        </Grid>
    );
};
